











































import { Vue, Prop, Component } from "vue-property-decorator";
import { SubscriptionFeature } from "@/modules/subscriptions/types";

@Component({})
export default class SubscriptionBox extends Vue {
  @Prop({ default: "" }) readonly subscriptionPlanId!: string;
  @Prop({ default: "0" }) verificationPrice!: string;
  @Prop({ default: "Sandbox" }) subcriptionPlanName!: string;
  @Prop({ default: "1,000" }) verificationsPerMonth!: string;
  @Prop({ default: "99" }) subscriptionCost: string;
  @Prop({ default: true }) readonly isSandbox: string;

  isGrowthOrScale = () =>
    this.subcriptionPlanName === "Growth" ||
    this.subcriptionPlanName === "Scale";

  isScale = () => this.subcriptionPlanName === "Scale";

  features: SubscriptionFeature[] = [
    {
      id: "liveness-detection",
      name: "Liveness Detection",
      isSandboxFeature: true,
    },
    {
      id: "facial-comparision",
      name: "Facial Comparison",
      isSandboxFeature: true,
    },
    {
      id: "document-authenticity",
      name: "Document Authentication",
      isSandboxFeature: true,
    },
    {
      id: "webhooks-feature",
      name: "Webhook and API Access",
      isSandboxFeature: true,
    },
    {
      id: "automations-checks",
      name: "Automation Checks",
      isSandboxFeature: this.isGrowthOrScale(),
    },
    {
      id: "sdk-ui-customization",
      name: "UI Customization",
      isSandboxFeature: this.isGrowthOrScale(),
    },
    {
      id: "kyb-organization-check",
      name: "KYB Organisation Scan",
      isSandboxFeature: this.isScale(),
    },
    {
      id: "dedicated-support",
      name: "Dedicated Integration Support",
      isSandboxFeature: this.isScale(),
    },
  ];
}
